import Layout1x1 from 'components/Layout1x1';
import Line from 'components/Line';
import Link from 'next/link';

const AccessoriesCopy = () => (
  <>
    <Layout1x1>
      <h3 className="text-h2">About Our Tuxedo & Suit Accessories</h3>
      <Line />
      <p>
        The perfect formalwear look isn't just about picking out a suit and tuxedo. It's all about styling your suit or
        tuxedo with the perfect accessories. These little touches can make or break your look.
      </p>
    </Layout1x1>

    <Layout1x1 className="mt-56">
      <h3 className="text-h2">Pocket Squares</h3>
      <p>
        Add a pop of color to your look with a{' '}
        <Link href="/collection/accessories?type=Pocket+Squares" replace={true}>
          <a className="tracker-text-collection-accessories_pocket_squares-221228-103100">pocket square</a>
        </Link>
        . Available in a{' '}
        <Link href="/swatch/build?swatches=">
          <a className="tracker-text-collection-swatches-221226-155100">variety of colors</a>
        </Link>
        , a pocket square can express your creativity. Try some decorative folds to show off your handiwork and your
        style.
      </p>
    </Layout1x1>

    <Layout1x1 className="mt-56">
      <h3 className="text-h2">Lapel Pins</h3>
      <p>
        Add a pop of color to your lapel with a{' '}
        <Link href="/collection/accessories?type=Lapel+Pins" replace={true}>
          <a className="tracker-text-collection-accessories_lapel_pins-221228-104500">lapel pin</a>
        </Link>
        . If you don't want to go with a fresh boutonniere, a lapel pin is the perfect alternative. In rose and
        carnation versions and in a variety of colors, you can add a bit of floral fun to every look.
      </p>
    </Layout1x1>

    <Layout1x1 className="mt-56">
      <h3 className="text-h2">Cufflinks and Studs</h3>
      <p>
        Finish off your tuxedo look with the perfect{' '}
        <Link href="/collection/accessories?type=Cufflinks" replace={true}>
          <a className="tracker-text-collection-accessories_cufflinks-221228-104500">cufflinks</a>
        </Link>{' '}
        and shirt studs. Gold and silver cufflinks and studs will complete your look, complementing rings and watches.
      </p>
    </Layout1x1>

    <Layout1x1 className="mt-56">
      <h3 className="text-h2">Suit Belts and Tuxedo Suspenders</h3>
      <p>
        Add a touch of perfection to your look by adding a{' '}
        <Link href="/collection/accessories?type=Belt" replace={true}>
          <a className="tracker-text-collection-accessories_belts-221228-104700">belt</a>
        </Link>{' '}
        to your suit and tuxedo{' '}
        <Link href="/collection/accessories?type=Suspenders" replace={true}>
          <a className="tracker-text-collection-accessories_suspenders-221228-104800">suspenders</a>
        </Link>
        . These finishing touches will complete your look and will have all eyes on you.
      </p>
    </Layout1x1>
  </>
);

export default AccessoriesCopy;
